// extracted by mini-css-extract-plugin
module.exports = {"paper":"styles_paper__14MFL"};